(function () {
    'use strict';

    angular
        .module('app.help')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
            {
                state: 'help',
                config: {
                    url: '/help',
                    templateUrl: 'app/help/help.html?v=' + opsIncludeVersion,
                    controller: 'HelpController',
                    controllerAs: 'vm',
                    title: 'Help',
                    settings: {
                        content: '<i class="fa fa-question"></i> <span class="leftNavText">Help</span>',
                    }
                    
                }
            }
        ];
    }
})();
